import React, { useEffect, useState } from "react";
import {
  getJogadoresTime1,
  getJogadoresTime2,
  substituirJogadorNoDB,
  registrarGolEAssistencia,
  getTeamVictories,
} from "../../../db/db"; // Importar as funções corretas
import "./TimesEmCampo.css";

const TimesEmCampo = ({
  time1Atualizado,
  time2Atualizado,
  reservasAtualizados,
  onReservasAtualizadas,
  isDadosIndividuaisOn,
  refreshVictories,
  setRefreshVictories,
  resetGolsTrigger,
  onColorChange,
  initialCorTime1,
  initialCorTime2,
  onScoreChange,
  onRegistrarJogada,
  goleiroTime1,
  goleiroTime2,
  onDefinirGoleiro,
  onRemoverGoleiro,
}) => {
  const [time1, setTime1] = useState([]);
  const [time2, setTime2] = useState([]);
  const [golsTime1, setGolsTime1] = useState(0); // Estado para o placar do Time 1
  const [golsTime2, setGolsTime2] = useState(0); // Estado para o placar do Time 2
  const [isModalSubOpen, setIsModalSubOpen] = useState(false);
  const [jogadorSelecionado, setJogadorSelecionado] = useState({});
  const [isModalCorOpen, setisModalCorOpen] = useState(false);
  const [isModalGolOpen, setIsModalGolOpen] = useState(false);
  const [corTemporaria, setCorTemporaria] = useState("");
  const [timeSelecionado, setTimeSelecionado] = useState(null);
  const [corTime1, setCorTime1] = useState(initialCorTime1); // Cor inicial do Time 1
  const [corTime2, setCorTime2] = useState(initialCorTime2); // Cor inicial do Time 2
  const [jogadorGol, setJogadorGol] = useState(null);
  const [jogadorAssistencia, setJogadorAssistencia] = useState(null);
  const [victoriesTime1, setVictoriesTime1] = useState(0);
  const [victoriesTime2, setVictoriesTime2] = useState(0);
  const [isModalGoleiroOpen, setIsModalGoleiroOpen] = useState(false);
  const [timeGoleiroSelecionado, setTimeGoleiroSelecionado] = useState(null);

  // Atualiza time1 e time2 quando forem alterados nas props
  useEffect(() => {
    if (time1Atualizado.length > 0) {
      setTime1(time1Atualizado);
    }
  }, [time1Atualizado]);

  useEffect(() => {
    if (time2Atualizado.length > 0) {
      setTime2(time2Atualizado);
    }
  }, [time2Atualizado]);

  useEffect(() => {
    setCorTime1(initialCorTime1);
  }, [initialCorTime1]);

  useEffect(() => {
    setCorTime2(initialCorTime2);
  }, [initialCorTime2]);

  useEffect(() => {
    if (typeof onScoreChange === "function") {
      onScoreChange({ time1: golsTime1, time2: golsTime2 });
    }
  }, [golsTime1, golsTime2, onScoreChange]);

  // Buscar os jogadores do IndexedDB (chama-se no carregamento inicial)
  useEffect(() => {
    fetchTimes();
    fetchVictories();
  }, [refreshVictories]);

  // Resetar gols quando resetGolsTrigger mudar
  useEffect(() => {
    setGolsTime1(0);
    setGolsTime2(0);
  }, [resetGolsTrigger]);

  const fetchVictories = async () => {
    const v1 = await getTeamVictories("time1");
    const v2 = await getTeamVictories("time2");
    setVictoriesTime1(v1 ? v1.victories : 0);
    setVictoriesTime2(v2 ? v2.victories : 0);
  };

  const abrirModalCor = (time) => {
    setTimeSelecionado(time); // Define o time a ser alterado (1 ou 2)
    setCorTemporaria(time === 1 ? corTime1 : corTime2); // Define a cor temporária com a cor atual do time
    setisModalCorOpen(true);
  };

  const fecharModalCor = () => {
    setisModalCorOpen(false);
    setCorTemporaria("");
    setTimeSelecionado(null);
  };

  const aplicarCor = () => {
    if (timeSelecionado === 1) {
      setCorTime1(corTemporaria);
      if (onColorChange) onColorChange(1, corTemporaria);
    } else if (timeSelecionado === 2) {
      setCorTime2(corTemporaria);
      if (onColorChange) onColorChange(2, corTemporaria);
    }
    fecharModalCor();
  };

  const abrirModalGol = (time) => {
    if (!isDadosIndividuaisOn) {
      // Apenas soma o gol diretamente no placar
      if (time === 1) {
        setGolsTime1(golsTime1 + 1);
      } else if (time === 2) {
        setGolsTime2(golsTime2 + 1);
      }
      return;
    }
    // Caso isDadosIndividuaisOn seja true, abre o modal
    setTimeSelecionado(time);
    setIsModalGolOpen(true);
  };

  const selecionarGol = (id) => {
    // Se já está selecionado, desmarca. Caso contrário, marca o jogador atual.
    setJogadorGol(jogadorGol === id ? null : id);
  };

  const selecionarAssistencia = (id) => {
    // Se já está selecionado, desmarca. Caso contrário, marca o jogador atual.
    setJogadorAssistencia(jogadorAssistencia === id ? null : id);
  };

  const salvarGol = async () => {
    if (!jogadorGol) {
      alert("Selecione o jogador que marcou o gol.");
      return;
    }

    const elencoDoTime =
      timeSelecionado === 1
        ? [...time1, ...(goleiroTime1 ? [goleiroTime1] : [])]
        : [...time2, ...(goleiroTime2 ? [goleiroTime2] : [])];

    // Encontrar os jogadores pelo id_fixo
    const jogadorGolSelecionado = elencoDoTime.find(
      (jogador) => jogador.id_fixo === jogadorGol
    );
    const jogadorAssistenciaSelecionado = elencoDoTime.find(
      (jogador) => jogador.id_fixo === jogadorAssistencia
    );

    // Verificar se os jogadores foram encontrados
    if (!jogadorGolSelecionado) {
      alert("Erro ao encontrar o jogador que marcou o gol.");
      return;
    }

    const idFixoGol = jogadorGolSelecionado.id_fixo;
    const idFixoAssistencia = jogadorAssistenciaSelecionado
      ? jogadorAssistenciaSelecionado.id_fixo
      : null;

    // Atualiza o saldo de gols do time
    if (timeSelecionado === 1) {
      setGolsTime1(golsTime1 + 1);
    } else if (timeSelecionado === 2) {
      setGolsTime2(golsTime2 + 1);
    }

    // Registra o gol e a assistência no banco de dados usando o id_fixo
    const sucesso = await registrarGolEAssistencia(
      idFixoGol,
      idFixoAssistencia
    );

    if (!sucesso) {
      alert("Erro ao registrar o gol e a assistência.");
      return;
    }

    if (typeof onRegistrarJogada === "function") {
      onRegistrarJogada({
        idGol: idFixoGol,
        idAssist: idFixoAssistencia,
      });
    }

    // Resetar os estados e fechar o modal
    setJogadorGol(null);
    setJogadorAssistencia(null);
    setIsModalGolOpen(false);
  };

  const fetchTimes = async () => {
    try {
      const time1Jogadores = await getJogadoresTime1(); // Pega os jogadores do time 1
      const time2Jogadores = await getJogadoresTime2(); // Pega os jogadores do time 2

      setTime1(time1Jogadores); // Atualiza o estado de time 1
      setTime2(time2Jogadores); // Atualiza o estado de time 2
    } catch (error) {
      console.error("Erro ao buscar os jogadores dos times:", error);
    }
  };

  const removerGolTime1 = () => {
    if (golsTime1 > 0) setGolsTime1(golsTime1 - 1); // Não permitir valores negativos
  };
  const removerGolTime2 = () => {
    if (golsTime2 > 0) setGolsTime2(golsTime2 - 1); // Não permitir valores negativos
  };

  const handleSubstituirJogadorTime1 = async (id) => {
    const jogador = time1.find((jogador) => jogador.id === id);
    setJogadorSelecionado({ ...jogador, time: "time1" }); // Marca que o jogador pertence ao time1
    setIsModalSubOpen(true);
  };

  const handleSubstituirJogadorTime2 = async (id) => {
    const jogador = time2.find((jogador) => jogador.id === id);
    setJogadorSelecionado({ ...jogador, time: "time2" }); // Marca que o jogador pertence ao time2
    setIsModalSubOpen(true);
  };

  const substituirJogador = async (jogadorId, reservaId, time) => {
    const sucesso = await substituirJogadorNoDB(jogadorId, reservaId, time);

    if (sucesso) {
      setIsModalSubOpen(false); // Fecha o modal após a operação
      onReservasAtualizadas();
      fetchTimes();
    } else {
      alert("Ocorreu um erro ao tentar substituir o jogador.");
    }
  };

  const abrirModalGoleiro = (time) => {
    setTimeGoleiroSelecionado(time);
    setIsModalGoleiroOpen(true);
  };

  const fecharModalGoleiro = () => {
    setIsModalGoleiroOpen(false);
    setTimeGoleiroSelecionado(null);
  };

  const selecionarGoleiro = async (reservaId) => {
    if (!timeGoleiroSelecionado || !onDefinirGoleiro) return;
    await onDefinirGoleiro(timeGoleiroSelecionado, reservaId);
    fecharModalGoleiro();
  };

  const removerGoleiro = async (time) => {
    const alvo = time || timeGoleiroSelecionado;
    if (!alvo || !onRemoverGoleiro) return;
    await onRemoverGoleiro(alvo);
    fecharModalGoleiro();
  };

  return (
    <div className="topo-times">
      <div
        className="topo-time-1"
        style={{
          border: `4px solid ${corTime1}`,
          backgroundColor: `${corTime1}`,
        }}
      >
        <label
          className="label-time-1"
          style={{ backgroundColor: `${corTime1}` }}
        >
          <button onClick={() => abrirModalCor(1)}>Cor</button>
          {victoriesTime1 > 0 && (
            <div className="victories-display">
              <span>{victoriesTime1}V</span>
            </div>
          )}
        </label>
        <div className="gols-time-1">
          <div className="add" id="add-gol-1" onClick={() => abrirModalGol(1)}>
            <svg
              width="20"
              height="20"
              viewBox="0 0 46 46"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3 23H43M23 3V43"
                stroke="white"
                stroke-width="5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>

          <span className="gols-1">{golsTime1}</span>

          <div className="remove" id="remove-gol-1" onClick={removerGolTime1}>
            <svg
              width="15"
              height="10"
              viewBox="0 0 46 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3 3H43"
                stroke="white"
                stroke-width="5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
        <div className="lista-jogadores-time-1">
          {time1.map((jogador) => (
            <div key={jogador.id} className="jogador-time-1">
              {jogador.nome} {/* Exibir o nome do jogador */}
              <button onClick={() => handleSubstituirJogadorTime1(jogador.id)}>
                <svg
                  width="15"
                  viewBox="0 0 69 80"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M67.6306 25.1213C68.8022 23.9497 68.8022 22.0503 67.6306 20.8787L48.5387 1.7868C47.3672 0.615224 45.4677 0.615224 44.2961 1.7868C43.1245 2.95837 43.1245 4.85786 44.2961 6.02944L61.2667 23L44.2961 39.9706C43.1245 41.1421 43.1245 43.0416 44.2961 44.2132C45.4677 45.3848 47.3672 45.3848 48.5387 44.2132L67.6306 25.1213ZM11 26H65.5093V20H11V26Z"
                    fill="#000"
                  />
                  <path
                    d="M0.874026 55.3787C-0.297547 56.5503 -0.297547 58.4497 0.874026 59.6213L19.9659 78.7132C21.1375 79.8848 23.037 79.8848 24.2085 78.7132C25.3801 77.5416 25.3801 75.6421 24.2085 74.4706L7.23799 57.5L24.2085 40.5294C25.3801 39.3579 25.3801 37.4584 24.2085 36.2868C23.037 35.1152 21.1375 35.1152 19.9659 36.2868L0.874026 55.3787ZM57.5046 54.5L2.99535 54.5V60.5L57.5046 60.5V54.5Z"
                    fill="#000"
                  />
                </svg>
              </button>
            </div>
          ))}
          <div
            className="jogador-gol"
            role="button"
            tabIndex={0}
            onClick={() => abrirModalGoleiro(1)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                abrirModalGoleiro(1);
              }
            }}
          >
            <div className="goleiro-icon">
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9 3L4 8V21H10V13H14V21H20V8L15 3H9Z"
                  stroke="#0f7a23"
                  strokeWidth="2"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className="goleiro-info">
              <span className="goleiro-label">Goleiro</span>
              <strong>{goleiroTime1 ? goleiroTime1.nome : "Gol vazio"}</strong>
            </div>
            {goleiroTime1 && (
              <button
                className="goleiro-remove"
                onClick={(e) => {
                  e.stopPropagation();
                  removerGoleiro(1);
                }}
                aria-label="Remover goleiro do Time 1"
              >
                Remover
              </button>
            )}
          </div>
        </div>
      </div>
      <span className="versus">X</span>
      <div
        className="topo-time-2"
        style={{
          border: `4px solid ${corTime2}`,
          backgroundColor: `${corTime2}`,
        }}
      >
        <label
          className="label-time-2"
          style={{ backgroundColor: `${corTime2}` }}
        >
          <button onClick={() => abrirModalCor(2)}>Cor</button>
          {victoriesTime2 > 0 && (
            <div className="victories-display">
              <span>{victoriesTime2}V</span>
            </div>
          )}
        </label>
        <div className="gols-time-2">
          <div className="add" id="add-gol-2" onClick={() => abrirModalGol(2)}>
            <svg
              width="20"
              height="20"
              viewBox="0 0 46 46"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3 23H43M23 3V43"
                stroke="white"
                stroke-width="5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <span className="gols-2">{golsTime2}</span>
          <div className="remove" id="remove-gol-2" onClick={removerGolTime2}>
            <svg
              width="15"
              height="10"
              viewBox="0 0 46 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3 3H43"
                stroke="white"
                stroke-width="5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
        <div className="lista-jogadores-time-2">
          {time2.map((jogador) => (
            <div key={jogador.id} className="jogador-time-2">
              {jogador.nome} {/* Exibir o nome do jogador */}
              <button onClick={() => handleSubstituirJogadorTime2(jogador.id)}>
                <svg
                  width="15"
                  viewBox="0 0 69 80"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M67.6306 25.1213C68.8022 23.9497 68.8022 22.0503 67.6306 20.8787L48.5387 1.7868C47.3672 0.615224 45.4677 0.615224 44.2961 1.7868C43.1245 2.95837 43.1245 4.85786 44.2961 6.02944L61.2667 23L44.2961 39.9706C43.1245 41.1421 43.1245 43.0416 44.2961 44.2132C45.4677 45.3848 47.3672 45.3848 48.5387 44.2132L67.6306 25.1213ZM11 26H65.5093V20H11V26Z"
                    fill="#000"
                  />
                  <path
                    d="M0.874026 55.3787C-0.297547 56.5503 -0.297547 58.4497 0.874026 59.6213L19.9659 78.7132C21.1375 79.8848 23.037 79.8848 24.2085 78.7132C25.3801 77.5416 25.3801 75.6421 24.2085 74.4706L7.23799 57.5L24.2085 40.5294C25.3801 39.3579 25.3801 37.4584 24.2085 36.2868C23.037 35.1152 21.1375 35.1152 19.9659 36.2868L0.874026 55.3787ZM57.5046 54.5L2.99535 54.5V60.5L57.5046 60.5V54.5Z"
                    fill="#000"
                  />
                </svg>
              </button>
            </div>
          ))}
          <div
            className="jogador-gol"
            role="button"
            tabIndex={0}
            onClick={() => abrirModalGoleiro(2)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                abrirModalGoleiro(2);
              }
            }}
          >
            <div className="goleiro-icon">
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9 3L4 8V21H10V13H14V21H20V8L15 3H9Z"
                  stroke="#0f7a23"
                  strokeWidth="2"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className="goleiro-info">
              <span className="goleiro-label">Goleiro</span>
              <strong>{goleiroTime2 ? goleiroTime2.nome : "Gol vazio"}</strong>
            </div>
            {goleiroTime2 && (
              <button
                className="goleiro-remove"
                onClick={(e) => {
                  e.stopPropagation();
                  removerGoleiro(2);
                }}
                aria-label="Remover goleiro do Time 2"
              >
                Remover
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Modal de substiuir Jogador */}
      {isModalSubOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-content-top">
              <strong>Substituir Jogador</strong>
              <button
                className="modal-cancel"
                onClick={() => setIsModalSubOpen(false)}
              >
                X
              </button>
            </div>
            <div className="modal-content-body">
              <div className="jogador-de-saida">
                <strong>{jogadorSelecionado.nome}</strong>
                <div className="icon-saida">
                  <svg
                    width="25"
                    viewBox="0 0 69 80"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M67.6306 25.1213C68.8022 23.9497 68.8022 22.0503 67.6306 20.8787L48.5387 1.7868C47.3672 0.615224 45.4677 0.615224 44.2961 1.7868C43.1245 2.95837 43.1245 4.85786 44.2961 6.02944L61.2667 23L44.2961 39.9706C43.1245 41.1421 43.1245 43.0416 44.2961 44.2132C45.4677 45.3848 47.3672 45.3848 48.5387 44.2132L67.6306 25.1213ZM11 26H65.5093V20H11V26Z"
                      fill="#FFF"
                    />
                    <path
                      d="M0.874026 55.3787C-0.297547 56.5503 -0.297547 58.4497 0.874026 59.6213L19.9659 78.7132C21.1375 79.8848 23.037 79.8848 24.2085 78.7132C25.3801 77.5416 25.3801 75.6421 24.2085 74.4706L7.23799 57.5L24.2085 40.5294C25.3801 39.3579 25.3801 37.4584 24.2085 36.2868C23.037 35.1152 21.1375 35.1152 19.9659 36.2868L0.874026 55.3787ZM57.5046 54.5L2.99535 54.5V60.5L57.5046 60.5V54.5Z"
                      fill="#FFF"
                    />
                  </svg>
                </div>
              </div>

              <div className="area-lista-reserva">
                {reservasAtualizados.map((reserva) => (
                  <div key={reserva.id} className="lista-reservas-sub">
                    {reserva.nome} {/* Exibir o nome do reserva */}
                    <button
                      className="reservas-sub"
                      onClick={() =>
                        substituirJogador(
                          jogadorSelecionado.id,
                          reserva.id,
                          jogadorSelecionado.time
                        )
                      }
                    >
                      <svg
                        width="25"
                        viewBox="0 0 69 80"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M67.6306 25.1213C68.8022 23.9497 68.8022 22.0503 67.6306 20.8787L48.5387 1.7868C47.3672 0.615224 45.4677 0.615224 44.2961 1.7868C43.1245 2.95837 43.1245 4.85786 44.2961 6.02944L61.2667 23L44.2961 39.9706C43.1245 41.1421 43.1245 43.0416 44.2961 44.2132C45.4677 45.3848 47.3672 45.3848 48.5387 44.2132L67.6306 25.1213ZM11 26H65.5093V20H11V26Z"
                          fill="#FFF"
                        />
                        <path
                          d="M0.874026 55.3787C-0.297547 56.5503 -0.297547 58.4497 0.874026 59.6213L19.9659 78.7132C21.1375 79.8848 23.037 79.8848 24.2085 78.7132C25.3801 77.5416 25.3801 75.6421 24.2085 74.4706L7.23799 57.5L24.2085 40.5294C25.3801 39.3579 25.3801 37.4584 24.2085 36.2868C23.037 35.1152 21.1375 35.1152 19.9659 36.2868L0.874026 55.3787ZM57.5046 54.5L2.99535 54.5V60.5L57.5046 60.5V54.5Z"
                          fill="#FFF"
                        />
                      </svg>
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal para seleção de cor */}
      {isModalCorOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-content-top">
              <h3>
                Escolha a cor do {timeSelecionado === 1 ? "Time 1" : "Time 2"}
              </h3>
              <input
                type="color"
                value={corTemporaria}
                onChange={(e) => setCorTemporaria(e.target.value)}
              />
            </div>
            <div className="modal-actions">
              <button className="modal-confirm" onClick={aplicarCor}>
                Aplicar
              </button>
              <button className="modal-cancel" onClick={fecharModalCor}>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Adicionar gol à Jogador */}
      {isModalGolOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-content-top">
              <strong>
                Marcar Gol - {timeSelecionado === 1 ? "Time 1" : "Time 2"}
              </strong>
              <button
                className="modal-cancel"
                onClick={() => setIsModalGolOpen(false)}
              >
                X
              </button>
            </div>
            <div className="modal-content-body">
              <table>
                <thead>
                  <tr>
                    <th>Jogador</th>
                    <th>Gol</th>
                    <th>Assistência</th>
                  </tr>
                </thead>
                <tbody>
                  {(timeSelecionado === 1
                    ? [...time1, ...(goleiroTime1 ? [goleiroTime1] : [])]
                    : [...time2, ...(goleiroTime2 ? [goleiroTime2] : [])]
                  ).map((jogador) => (
                    <tr key={jogador.id_fixo || jogador.id}>
                      <td>{jogador.nome}</td>
                      <td>
                        <input
                          type="checkbox"
                          checked={jogadorGol === jogador.id_fixo}
                          onChange={() => selecionarGol(jogador.id_fixo)}
                        />
                      </td>
                      <td>
                        <input
                          type="checkbox"
                          checked={jogadorAssistencia === jogador.id_fixo}
                          onChange={() => selecionarAssistencia(jogador.id_fixo)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="modal-actions">
                <button className="modal-confirm" onClick={salvarGol}>
                  Salvar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal para seleção de goleiro */}
      {isModalGoleiroOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-content-top">
              <strong>
                {timeGoleiroSelecionado === 1
                  ? "Goleiro do Time 1"
                  : "Goleiro do Time 2"}
              </strong>
              <button className="modal-cancel" onClick={fecharModalGoleiro}>
                X
              </button>
            </div>
            <div className="modal-content-body">
              <p className="goleiro-modal-helper">
                Escolha um jogador das reservas para assumir o gol. O jogador sai
                da fila de linha e segue acumulando estatísticas da partida.
              </p>
              {((timeGoleiroSelecionado === 1 && goleiroTime1) ||
                (timeGoleiroSelecionado === 2 && goleiroTime2)) && (
                <div className="goleiro-atual">
                  <span className="goleiro-label">Atual</span>
                  <strong>
                    {timeGoleiroSelecionado === 1
                      ? goleiroTime1?.nome
                      : goleiroTime2?.nome}
                  </strong>
                  <button
                    className="goleiro-remove"
                    onClick={() => removerGoleiro(timeGoleiroSelecionado)}
                  >
                    Remover e devolver para reservas
                  </button>
                </div>
              )}
              <div className="area-lista-reserva">
                {reservasAtualizados.length === 0 && (
                  <div className="lista-reservas-sub muted">
                    Nenhum jogador disponível nas reservas.
                  </div>
                )}
                {reservasAtualizados.map((reserva) => (
                  <div key={reserva.id} className="lista-reservas-sub">
                    {reserva.nome}
                    <button
                      className="reservas-sub"
                      onClick={() => selecionarGoleiro(reserva.id)}
                    >
                      Selecionar
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TimesEmCampo;
